import getApolloClient from '../graphql/client';

export const useApolloClient = (): any => {
  const client = getApolloClient();

  return client;
};
